import { EmployeeRole } from '@/api/apis/resources';
import { PERMISSIONS_BY_ROLES, PermissionType } from '@/permissions/roles';

export const getPermissionsList = (roles: EmployeeRole[]): PermissionType[] => {
  const permissions = Object.keys(PERMISSIONS_BY_ROLES).reduce<PermissionType[]>((acc, permission) => {
    const permissionKey = permission as PermissionType;
    const hasRole = PERMISSIONS_BY_ROLES[permissionKey].some((role) => roles.includes(role));

    if (hasRole) {
      return [...acc, permissionKey];
    }

    return acc;
  }, []);

  return Array.from(new Set(permissions));
};
